import m from "../../es2015/themes/patterns";
window.am4themes_patterns = m;


//////////////////
// WEBPACK FOOTER
// ./themes/patterns.js
// module id = null
// module chunks = 